var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowDecrease = function SvgArrowDecrease(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m14.93 6.806.813.793c.165.16.257.377.257.603a.843.843 0 0 1-.257.604L8.621 15.75a.888.888 0 0 1-.62.25.888.888 0 0 1-.618-.25L.256 8.806A.843.843 0 0 1 0 8.202c0-.226.092-.443.256-.603l.814-.793a.887.887 0 0 1 .632-.248.904.904 0 0 1 .625.262l4.204 4.3V.858A.836.836 0 0 1 6.788.25.88.88 0 0 1 7.41 0h1.173a.897.897 0 0 1 .623.25.854.854 0 0 1 .257.608V11.12l4.208-4.3a.875.875 0 0 1 .626-.267.895.895 0 0 1 .632.253Z",
    fill: "#CE6549"
  })));
};
export default SvgArrowDecrease;